

// this function expects each param to be from Date.now()
export const timeStampMinutesDifference = (time1, time2) => {
    let difference = time1 - time2;
    let minutesDifference = Math.floor(difference / 1000 / 60);

    return minutesDifference;
}